<template>
    <div style="margin: 1rem auto; max-width: 80rem;">
        <v-main>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" md="4">
                        <h1>Dashboard</h1>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card class="pa-4">
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y max-width="290px" min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="computedDateFormatted" label="Fecha" persistent-hint
                                        prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" outlined
                                        dense></v-text-field>
                                </template>
                                <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
                            </v-menu>

                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card class="pa-4 container-card">
                            <v-card-title>Capacidad total</v-card-title>
                            <v-card-text style="font-size: 2rem">{{ arrayAcumulado[0] ? arrayAcumulado[0].cantidad :
                                null}}</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card color="green lighten-3" class="pa-4">
                            <v-card-title>Registros</v-card-title>
                            <v-card-text style="font-size: 2rem">{{ arrayAcumulado[0] ? arrayAcumulado[0].nro_registros
                                :null}}</v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card color="red lighten-4" class="pa-4">
                            <v-card-title>Avance</v-card-title>
                            <!-- <v-card-text>{{ arrayAcumulado[0]?arrayAcumulado[0].avance*100:null }}%</v-card-text> -->
                            <v-card-text style="font-size: 2rem">{{ arrayAcumulado[0] ? (arrayAcumulado[0].avance *
                                100).toFixed(2) :
                                null }}%</v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-card class="elevation-1" style="padding: 1.5rem;">
                            <canvas width="300" height="400" ref="chart1"></canvas>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card class="pa-4">

                        </v-card>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-card class="pa-4">

                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card class="pa-4">
                            <v-data-table :headers="headers" :items="arrayTable" sort-by="calories" class="elevation-1"
                                dense :items-per-page="15">
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <GmapMap :center="{ lat: -12.074928851253814, lng: -77.04316187097396 }" :zoom="11"
                        style="width: 100%; height: 40vh">
                        <GmapInfoWindow v-if="infoWindowOpened" :position="infoWindowPosition"
                            @closeclick="infoWindowOpened = false">
                            <div>
                                <div class="info-window-content" v-html="infoWindowContent"></div>
                            </div>
                        </GmapInfoWindow>
                        <!-- <GmapInfoWindow v-if="infoWindowOpenedClinica" :position="infoWindowPositionClinica"
        @closeclick="infoWindowOpenedClinica = false">
        <div class="info-window-content" v-html="infoWindowContentClinica"></div>
      </GmapInfoWindow> -->
                        <GmapMarker v-for="(marker, index) in arrayData" :key="'data-' + index"
                            :position="{ lat: parseFloat(marker.latitud), lng: parseFloat(marker.longitud) }"
                            @click="showInfoWindow(marker, index)" :clickable="true" :draggable="false" :icon="{
                                url: require('@/assets/punto.png'),
                                scaledSize: { width: 8, height: 8 }
                            }" />
                    </GmapMap>
                </v-row>
            </v-container>
        </v-main>
    </div>
</template>
<style>
.container-card {
    background-color: rgba(241, 241, 241, 0.712) !important;
}

.container-card-two {
    background-color: rgba(135, 255, 111, 0.945) !important;
}

.container-card-tree {
    background-color: rgba(241, 241, 241, 0.712) !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Chart from "chart.js";
export default {
    data() {
        return {
            //Terminado
            headers: [
                {
                    text: "Clínica",
                    align: "start",
                    sortable: false,
                    value: "descripCas",
                },
                { text: "Usuario", value: "usuario" },
                { text: "Frecuencia", value: "frecuencia" },
                { text: "Turno", value: "turno" },
                { text: "Cantidad", value: "cantidad" },
                { text: "Número registro", value: "numero_registro" }
                //{ text: "Actions", value: "actions", sortable: false },
            ],
            updates: [], // Aquí almacenarás los datos nuevos
            arrayData: [], // Aquí almacenarás los datos nuevos
            infoWindowOpened: false,
            infoWindowPosition: null,
            infoWindowContent: '',
            chart: null,
            labelColum1: ['Faltantes','Registrados'],
            chartData1: [],
            title1: "Encuestados",
            date: null,
            modal: false,
            menu: false,
            dateFormat: '',
            intervalId: null,
            dateOld: null,
            controller: null, // Controlador para abortar la solicitud
            currentPollingDate: null,
            arrayTable: [],
            arrayAcumulado: []
        };
    },
    methods: {
        saveDate() {

        },
        renderChart1(canvas, data, label) {
            if (this.chart) {
                this.chart.destroy();  // Destruir gráfico anterior
            }
            this.chart = new Chart(canvas, {
                type: 'doughnut',  // Cambia el tipo de gráfico aquí
                data: {
                    labels: this.labelColum1,
                    datasets: [
                        {
                            label: label,
                            data: data,
                            backgroundColor: [
                                "rgba(75, 192, 192, 0.2)",
                                "rgba(54, 162, 235, 0.2)",
                                "rgba(255, 206, 86, 0.2)",
                                "rgba(75, 192, 192, 0.2)",
                            ],
                            borderColor: [
                                "rgba(75, 192, 192, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                            ],
                            borderWidth: 1,
                        },
                    ],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '0%', 
                    plugins: {
                        tooltip: {
                            enabled: true,
                        },
                    },
                    animation: false,
                },
                plugins: [{
                    // Usa afterDraw para dibujar los valores sobre los segmentos
                    afterDraw: (chart) => {
                        const ctx = chart.ctx;
                        chart.data.datasets.forEach((dataset, datasetIndex) => {
                            const meta = chart.getDatasetMeta(datasetIndex);
                            meta.data.forEach((point, index) => {
                                const value = dataset.data[index];
                                const posX = point.tooltipPosition().x;
                                const posY = point.tooltipPosition().y;
                                ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
                                ctx.font = 'bold 12px Arial';
                                ctx.textAlign = 'center';
                                ctx.fillText(value + '%', posX, posY);
                            });
                        });
                    }
                }]
            });
        },
        showInfoWindow(marker, index) {
            this.infoWindowPosition = {
                lat: parseFloat(marker.latitud),
                lng: parseFloat(marker.longitud)
            };
            this.infoWindowContent = `<div class="text-negra"><b>${marker.nombres}</b></div><br><div class="text-content"><b>DNI:</b> ${marker.dni}<br/><b>Usuario:</b> ${marker.usuario}</div>`;
            this.infoWindowOpened = true;
        },
        listPacientes() {
            console.log("datos extraido asdasd")
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/dashboardEncuesta/",
                            { fecha: this.date ? this.formatDate(this.date) : null },
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            if (res.data.hasUpdates) {
                                this.arrayData = res.data.registros_mapa;
                                this.arrayTable = res.data.registros_tabla;
                                this.arrayAcumulado = res.data.registro_acumulado;
                                const graficoCantidad= [];
                    
                                for (let i = 0; i < this.arrayAcumulado.length; i++) {
                                    const element = this.arrayAcumulado[i];
                                    let porcentaje1 = (element.avance * 100).toFixed(2);
                                    let porcentaje2 = ((1 - Number(element.avance)) * 100).toFixed(2);
                                    graficoCantidad.push(porcentaje1);
                                    graficoCantidad.push(porcentaje2);
                                }
                                this.renderChart1(this.$refs.chart1, graficoCantidad, "Hemoglobina", 'doughnut');
                            }
                        })
                        .catch((error) => {

                        });
                })
                .catch((error) => {


                });
        },
        longPoll() {
            // Si la fecha actual de polling es distinta de la fecha seleccionada, detener el polling
            if (this.currentPollingDate && this.currentPollingDate !== this.date) {
                console.log("Fecha cambiada, cancelando la solicitud y reiniciando.");
                return; // No reinicia el polling automáticamente
            }

            // Cancelar cualquier solicitud pendiente antes de comenzar una nueva
            if (this.controller) {
                this.controller.abort();
            }

            // Establecer la fecha actual de polling
            this.currentPollingDate = this.date;

            // Crear un nuevo AbortController para la nueva solicitud
            this.controller = new AbortController();
            const { signal } = this.controller;

            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(
                            RUTA_API + "/long_poll_updates/",
                            { fecha: this.formatDate(this.date) },
                            {
                                headers: { Authorization: this.auth },
                                signal: signal
                            }
                        )
                        .then((res) => {
                            if (res.data.hasUpdates) {
                                this.arrayData = res.data.registros_mapa;
                                this.arrayTable = res.data.registros_tabla;
                                this.arrayAcumulado = res.data.registro_acumulado;
                                const graficoCantidad= [];
                    
                                for (let i = 0; i < this.arrayAcumulado.length; i++) {
                                    const element = this.arrayAcumulado[i];
                                    let porcentaje1 = (element.avance * 100).toFixed(2);
                                    let porcentaje2 = ((1 - Number(element.avance)) * 100).toFixed(2);
                                    graficoCantidad.push(porcentaje1);
                                    graficoCantidad.push(porcentaje2);
                                }
                                this.renderChart1(this.$refs.chart1, graficoCantidad, "Hemoglobina", 'doughnut');
                            }
                            // Reinicia la conexión solo si la fecha no ha cambiado
                            if (this.currentPollingDate === this.date) {
                                this.longPoll();
                            }
                        })
                        .catch((error) => {
                            if (error.name === "CanceledError") {
                                console.log("Solicitud cancelada.");
                            } else {
                                console.error("Error en la consulta larga:", error);
                                setTimeout(() => {
                                    if (this.currentPollingDate === this.date) {
                                        this.longPoll();
                                    }
                                }, 10000);
                            }
                        });
                })
                .catch((error) => {
                    console.error("Error en la autenticación:", error);
                    setTimeout(() => {
                        if (this.currentPollingDate === this.date) {
                            this.longPoll();
                        }
                    }, 10000);
                });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            this.dateFormat = `${day}-${month}-${year}`;
            return `${day}-${month}-${year}`;
        },
        restartLongPoll() {
            // Actualiza la fecha de polling actual y reinicia `longPoll`
            this.currentPollingDate = null; // Reinicia la fecha de polling actual
            this.longPoll(); // Llama a `longPoll` para iniciar una nueva solicitud
        }
    },
    watch: {
        date(newDate, oldDate) {
            this.listPacientes();
            if (newDate !== oldDate) {
                // Reinicia el polling cuando cambia la fecha
                this.restartLongPoll();
            }
        }
    },
    mounted() {
        this.longPoll(); // Inicia la consulta larga cuando el componente esté montado
    },
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
    },
    beforeDestroy() {
        // Cancela cualquier solicitud pendiente si el componente se destruye
        if (this.controller) {
            this.controller.abort();
        }
    },
    created() {
        this.listPacientes();
        this.formatDate(this.date);
    }
};
</script>